import getDataFrom from '@/mixins/firestore/getDataFrom';
import { VOCABULARIES } from '@/config/firestore';

export default {
  mixins: [getDataFrom],
  methods: {
    async getMyVocabularyLanguageSets() {
      const languageSets = await this.getDataFrom(`${VOCABULARIES}_langs`);

      if (languageSets && typeof languageSets === 'object') {
        return languageSets.langs;
      }

      return [];
    },
  },
};
